import React, {useEffect} from 'react'
import styled from 'styled-components'
import AvatarImg from "../img/tmp/avatars/2.png"
import Like from "../img/icons/like.svg"
import LikeActive from "../img/icons/likeActive.svg"
import Dislike from "../img/icons/dislike.svg"
import DislikeActive from "../img/icons/dislikeActive.svg"
import { TextareaGroup } from "../components/Input";
import Avatar from "../components/Avatar";
import { handleBigNumbers } from "../utils"
import { ReactComponent as MoreIcon } from "../img/icons/more.svg";
import { ReactComponent as VerifiedIcon } from "../img/icons/verified.svg";

const CommentsSection = styled.section`
    width: 90%;
    display: flex;
    flex-direction: column;
    padding: 0px 30px 0 0;
`

const NewCommentStyle = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 17px;
`

const CommentStyle = styled.div`
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 18px;
`

const Header = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
`
const Text = styled.p`
    font-size: 14px;
    font-family: 'PT Serif';
    color : ${({ theme }) => theme.color.darkerText};
`

const Footer = styled.div`
    display: flex;
    gap: 15px;
`

const Counter = styled.p`
    font-size: 12px;
    font-family: 'Poppins Medium';
    color : ${({ theme }) => theme.color.lighterText};
`

const Reaction = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    margin-left: 15px;
    gap: 10px;
`

const Name = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`

const Date = styled.p`
    margin-left: 5px;
    font-size: 12px;
    font-family: 'Poppins Medium';
    color : ${({ theme }) => theme.color.lighterText};
`

const Icon = styled.img`
    width: 15px;
    height: 15px;
    cursor: pointer;
`
const Comment = () => {
    const [like, setLike] = React.useState(false)
    const [dislike, setDisLike] = React.useState(false)
    useEffect(() => {
        console.log("like: " + like,"dislike: " + dislike)
    }, [like, dislike])
    return (
        <CommentStyle>
            <Avatar size="44px" src={AvatarImg} />
            <Body>
                <Header>
                    <Name>
                        <h6>Justin brake</h6>
                        <VerifiedIcon />
                    </Name>
                    <MoreIcon />
                </Header>
                <Text>Faucibus convallis volutpat magnis viverra nec tellus sit tortor ut. Tincidunt in tristique eleifend quis felis morbi eget lacus. Diam, ultricies lacus urna sagittis pharetra cursus quis justo. </Text>
                <Footer>
                    <Reaction>
                        <Icon onClick={() => {
                            setLike(c => !c)
                            setDisLike(c => !like ? false : c)
                        }} src={(like) ? LikeActive : Like} alt="like" />
                        <Counter>{handleBigNumbers(12000)}</Counter>
                    </Reaction>
                    <Reaction>
                        <Icon onClick={() => {
                            setDisLike(c => !c)
                            setLike(c => !dislike ? false : c)
                        }} src={(dislike) ? DislikeActive : Dislike} alt="like" />
                        <Counter>{handleBigNumbers(10000)}</Counter>
                    </Reaction>
                    <Date>9 months ago</Date>
                </Footer>
            </Body>
        </CommentStyle>
    )
}

const NewComment = () => {
    return (
        <NewCommentStyle>
            <Avatar size="44px" src={AvatarImg} />
            <TextareaGroup minRows="1.5" style={{ height: "44px" }} placeholder="Add a comment" />
        </NewCommentStyle>
    )
}

export default function Comments() {
    return (
        <CommentsSection>
            <h6 style={{ marginBottom: "20px" }}>Comments</h6>
            <NewComment />
            <Comment />
        </CommentsSection>
    )
}
